export default [
  {
    path: "/design",
    name: "design",
    component: () => import("@/views/designModel"),
    meta: {
      title: "流程设计",
      keepAlive: true,
    },
  },
  {
    path: "/custom",
    name: "custom",
    component: () => import("@/views/customForm"),
    meta: {
      title: "自定义表单",
      keepAlive: true,
    },
  },
  {
    path: "/generator",
    name: "generator",
    component: () => import("@/views/customForm/formGenerator.vue"),
    meta: {
      title: "表单生成器",
      keepAlive: true,
    },
  },
  {
    path: "/model",
    name: "model",
    component: () => import("@/views/model"),
    meta: {
      title: "流程模型",
      keepAlive: true,
    },
  },
  {
    path: "/deploy",
    name: "deploy",
    component: () => import("@/views/deploy"),
    meta: {
      title: "部署管理",
      keepAlive: true,
    },
  },
  {
    path: "/definition",
    name: "definition",
    component: () => import("@/views/definition"),
    meta: {
      title: "流程定义",
      keepAlive: true,
    },
  },
  {
    path: "/processInitiation",
    name: "processInitiation",
    component: () => import("@/views/processInitiation"),
    meta: {
      title: "流程发起",
      keepAlive: true,
    },
  },
  {
    path: "/myInitiative",
    name: "myInitiative",
    component: () => import("@/views/myInitiative"),
    meta: {
      title: "我的发起",
      keepAlive: true,
    },
  },
  {
    path: "/myToDoList",
    name: "myToDoList",
    component: () => import("@/views/myToDoList"),
    meta: {
      title: "我的待办",
      keepAlive: true,
    },
  },
  {
    path: "/handle",
    name: "handle",
    component: () => import("@/views/handle"),
    meta: {
      title: "经办任务",
      keepAlive: true,
    },
  },
  {
    path: "/monitor",
    name: "monitor",
    component: () => import("@/views/monitor"),
    meta: {
      title: "监听器管理",
      keepAlive: true,
    },
  },
];
